import { render, staticRenderFns } from "./authorizationLoading.vue?vue&type=template&id=14332c15&scoped=true&"
import script from "./authorizationLoading.vue?vue&type=script&lang=js&"
export * from "./authorizationLoading.vue?vue&type=script&lang=js&"
import style0 from "./authorizationLoading.vue?vue&type=style&index=0&id=14332c15&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14332c15",
  null
  
)

export default component.exports